import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import ObservableOwaUserConfiguration from 'owa-session-store/lib/types/ObservableOwaUserConfiguration';
import { getOrigin, getRootVdirName } from 'owa-url';

export function getModuleIndexUrl() {
    const baseUrl = `${getOrigin()}/${getRootVdirName()}`;

    if (!isConsumer()) {
        return baseUrl;
    }
    const {
        SessionSettings: { UserEmailAddress },
    }: ObservableOwaUserConfiguration = getUserConfiguration();
    return `${baseUrl}/${UserEmailAddress}`;
}
